import { captureMessage } from '@sentry/react';
import { useState, useEffect } from 'react';

export const useCountryCode = () => {
  const [countryCode, setCountryCode] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountryInfo = async () => {
      try {
        setLoading(true);
        const apiUrl = `https://ipinfo.io/json`;
        const response = await fetch(apiUrl);
        await response
          .json()
          .then(data => setCountryCode(data.country))
          .catch(e => {
            captureMessage('Fetching country code error...', {
              tags: {
                error:
                  e.message ||
                  'Error while fetching country code with ipinfo.io'
              },
              level: 'error'
            });
          });
      } finally {
        setLoading(false);
      }
    };

    fetchCountryInfo();
  }, []);

  return { countryCode, loading };
};
